import { api } from '../../services/api';

export type DividaScope = 'federal' | 'estadual' | 'municipal' | 'inss' | 'fgts' | 'dirpf';

export interface DividaTributaria {
  id: number;
  customer_id: number;
  notification_date: string;
  scope: DividaScope;
  document_url: string | null;
  value: number;
  notes: string | null;
  created_at: string;
  updated_at: string;
}

export const getDividasTributarias = async (): Promise<DividaTributaria[]> => {
  const response = await api.get('/customer/dividas-tributarias');
  return response.data.data;
};

export const getDividaTributaria = async (id: number): Promise<DividaTributaria> => {
  const response = await api.get(`/customer/dividas-tributarias/${id}`);
  return response.data.data;
};

export const SCOPE_LABELS: Record<DividaScope, string> = {
  federal: 'FEDERAL',
  estadual: 'ESTADUAL',
  municipal: 'MUNICIPAL',
  inss: 'INSS',
  fgts: 'FGTS',
  dirpf: 'DIRPF',
};

export const SCOPE_COLORS: Record<DividaScope, string> = {
  federal: '#1890ff',
  estadual: '#52c41a',
  municipal: '#fa8c16',
  inss: '#722ed1',
  fgts: '#13c2c2',
  dirpf: '#f5222d',
};
